import * as React from 'react'

import type { Field } from 'factorial-form'

import { observer } from 'mobx-react'

import FilterSelect from 'modules/core/components/Inputs/FilterSelect'
import i18n from 'modules/core/lib/i18n'

import currencies from 'modules/settings/store/collections/currencies'

interface Props {
  field: Field
  readonly?: boolean
  label?: string
  secondaryLabel?: React.ReactNode | React.ReactNode[]
  autofilled?: boolean
  onChange?: (field: Field) => void
  filteredCurrencies?: string[]
}

const CurrencySelector = ({
  readonly = false,
  label = i18n.t('expenses_v2.account_form.currency'),
  autofilled = false,
  field,
  secondaryLabel,
  onChange,
  filteredCurrencies,
}: Props) => {
  React.useEffect(() => {
    currencies.fetch()
  }, [])
  const filteredCurrenciesSet = new Set(filteredCurrencies)

  const options = currencies.models
    .filter(
      (currency) =>
        !filteredCurrenciesSet.size || filteredCurrenciesSet?.has(currency.attributes.iso_code)
    )
    .map((currency) => {
      return {
        label: `${currency.attributes.symbol} ${currency.attributes.iso_code}`,
        subtitle: currency.attributes.name,
        value: currency.attributes.iso_code,
      }
    })

  return (
    <FilterSelect
      label={label}
      secondaryLabel={secondaryLabel}
      field={field}
      options={options}
      readonly={readonly}
      autofilled={autofilled}
      onChange={onChange}
      autoclose
    />
  )
}

export default observer(CurrencySelector)
